import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer>
      <div className="footer-logo-container">
        <img src="/PNG-02.png" alt="Talkbooks Logo" />
      </div>
      <p>&copy; 2025 Talkbooks. All rights reserved.</p>
      <p>Revolutionizing small business bookkeeping in India with AI-powered voice technology.</p>
      <p style={{ marginTop: '1rem', fontSize: '1.1rem', color: '#cbd5e1' }}>
        📞 Contact us: <a href="tel:+918658534494" style={{ color: '#a78bfa', textDecoration: 'none' }}>+91-8658534494</a> |
        <a href="tel:+917008054994" style={{ color: '#a78bfa', textDecoration: 'none' }}>+91-7008054994</a>
      </p>

      <div className="social-links">
        <a href="#" title="LinkedIn">💼</a>
        <a href="#" title="Twitter">🐦</a>
        <a href="#" title="Facebook">📘</a>
        <a href="#" title="Instagram">📸</a>
      </div>
    </footer>
  );
}

export default Footer;

